import { fetchData } from './fetch';

window.addEventListener('load', () => {
  const addressRadionInput = document.querySelectorAll('.address-radio');
  const restaurantRadionInput = document.querySelectorAll('.restaurant-radio');
  const addressStreetId = document.querySelector('.address-street-id');
  const restaurantId = document.querySelector('.restaurant-id');
  const addressTitleInput = document.querySelector('.address-title-input');
  const addressHouseInput = document.querySelector('.address-house-input');
  const addressStreetInput = document.querySelector('.address-street-input');
  const addressFlatInput = document.querySelector('.address-flat-input');
  const addressFloorInput = document.querySelector('.address-floor-input');
  const addressEntranceInput = document.querySelector(
    '.address-entrance-input',
  );
  const addressDeliveryOrganizationId = document.querySelector('.delivery-organization-id');
  const restaurantWorkTimeInput = document.querySelector(
    '.restaurant-work-time',
  );
  const restaurantHouseInput = document.querySelector(
    '.restaurant-house-input',
  );
  const newAddressInput = document.querySelector('.new-address .input-button');
  const backButton = document.querySelector('.address-form .back-btn');
  const addressFormSubmitButton = document.querySelector(
    '.address-form .address-submit',
  );
  const restaurantFormSubmitButton = document.querySelector(
    '.restaurant-form .address-submit',
  );
  const orderAddressForm = document.querySelector('.order-address-form');
  const textInput = document.querySelectorAll('.text-input');
  const floorInput = document.querySelector('.floor-input');
  const buildingInput = document.querySelector('.building-input');
  const streetInput = document.querySelector('.street-input');
  const addressTitle = document.querySelector('.address-title');
  const addressStreet = document.querySelector('.address-street');
  const addressFlat = document.querySelector('.address-flat');
  const addressEntrance = document.querySelector('.address-entrance');
  const streetIdInput = document.querySelector('.street-id-input');
  const streetsList = document.querySelector('.streets-list');
  const saveAddressCheckbox = document.querySelector('.save-address');
  const saveAddressInput = document.querySelector('.save-address-input');
  const addressTitleWrapper = document.querySelector('.address-title-wrapper');
  const addressHouseWrapper = document.querySelector('.address-house-wrapper');
  const addressStreetTitle = document.querySelector('.address-street-title');
  const addressTitleError = document.querySelector('.address-title-error');
  const addressStreetError = document.querySelector('.address-street-error');
  const addressHouseError = document.querySelector('.address-house-error');
  const newAddressCodeInput = document.querySelector('.new-address-code');
  const codeInput = document.querySelector('.order-address-form .code-input');
  const newAddressCommentInput = document.querySelector(
    '.new-address-comment-input',
  );
  const commentInput = document.querySelector(
    '.order-address-form .comment-input',
  );
  const addressLoader = document.querySelector(
    '.order-bottom .profile-form .address-loader',
  );

  let formValues = {};

  const formValuesFromSessionStorage = sessionStorage ? sessionStorage.getItem('formValues') : null;

  if (formValuesFromSessionStorage) {
    formValues = JSON.parse(formValuesFromSessionStorage);
  }

  if (formValues && Object.keys(formValues).length) {
    const {
      title,
      streetId,
      house,
      street,
      flat,
      floor,
      entrance,
      comment,
      deliveryOrganizationId,
      workTime,
      organizationId,
      restaurantHouse,
    } = formValues;

    // document.querySelectorAll(`[data-id="address-modal"]`)?.forEach(item => {
    //   if (item?.querySelector('.address-value')) {
    //     item.querySelector('.address-value').innerHTML = title
    //   }
    // })

    if (title && addressTitleInput) {
      addressTitleInput.value = title;
    }

    if (streetId && addressStreetId) {
      addressStreetId.value = streetId;

      if (addressFormSubmitButton) {
        addressFormSubmitButton.classList.remove('disabled');
      }
    }

    if (house && addressHouseInput) {
      addressHouseInput.value = house;
    }

    if (street && addressStreetInput) {
      addressStreetInput.value = street;
    }

    if (flat && addressFlatInput) {
      addressFlatInput.value = flat;
    }

    if (floor && addressFloorInput) {
      addressFloorInput.value = floor;
    }

    if (entrance && addressEntranceInput) {
      addressEntranceInput.value = entrance;
    }

    if (comment && commentInput) {
      commentInput.value = comment;
    }

    if (deliveryOrganizationId && addressDeliveryOrganizationId) {
      addressDeliveryOrganizationId.value = deliveryOrganizationId;
    }

    if (workTime && restaurantWorkTimeInput) {
      restaurantWorkTimeInput.value = workTime;
    }

    if (organizationId && restaurantId) {
      restaurantId.value = organizationId;

      if (restaurantFormSubmitButton) {
        restaurantFormSubmitButton.classList.remove('disabled');
      }
    }

    if (restaurantHouse && restaurantHouseInput) {
      restaurantHouseInput.value = restaurantHouse;
    }
  }

  if (addressRadionInput) {
    [].forEach.call(addressRadionInput, (input) => {
      if (
        formValues.streetId &&
        formValues.house &&
        formValues.streetId === input.dataset.streetid &&
        formValues.house === input.dataset.house
      ) {
        input.checked = true;
      }

      input.addEventListener('click', async () => {
        const {
          title,
          house,
          street,
          flat,
          floor,
          entrance,
          comment,
        } = input.dataset;
        const streetId = input.dataset.streetid;
        const parentElement = input.closest('.input-button-wrapper');

        formValues.menuType = 'delivery';

        input.checked = false;

        if (saveAddressInput) {
          saveAddressInput.value = '';
        }

        if (addressLoader) {
          addressLoader.classList.add('visible');
        }

        const deliveryAddress = `${street}, ${house}`;

        const response = await fetchData(`/order/delivery-availability?address=${deliveryAddress}&streetKladrId=${streetId}`);

        if (response) {
          if (addressLoader) {
            addressLoader.classList.remove('visible');
          }

          const organizationIdInput = document.querySelector('.order-address-form .delivery-organization-id');
          const addressFormButton = document.querySelector('.order-address-form .address-submit');

          if (!response.data.deliveryAvailable) {
            if (parentElement) {
              const errorMessage = parentElement.querySelector(
                '.delivery-area-error',
              );

              if (errorMessage) {
                errorMessage.classList.add('visible');
              }
            }

            if (addressFormButton && !addressFormButton.classList.contains('disabled')) {
              addressFormButton.classList.add('disabled');
            }

            if (organizationIdInput && organizationIdInput.value) {
              organizationIdInput.value = '';
            }

            if (formValues.deliveryOrganizationId) {
              formValues.deliveryOrganizationId = '';

              if (sessionStorage) {
                sessionStorage.setItem(
                  'formValues',
                  JSON.stringify(formValues),
                );
              }
            }
          } else {
            input.checked = true;

            const popupButton = document.querySelector('#address-modal .popup-overlay')
            if (popupButton) {
              popupButton.click()
            }

            // document.querySelectorAll(`[data-id="address-modal"]`)?.forEach(item => {
            //   if (item?.querySelector('.address-value')) {
            //     item.querySelector('.address-value').innerHTML = title
            //   }
            // })

            const errorMessages = document.querySelectorAll(
              '.delivery-area-error',
            );

            if (errorMessages) {
              [].forEach.call(errorMessages, (message) =>
                message.classList.remove('visible'),
              );
            }

            const organizationIdFromApi = response.data.organizationId;

            if (addressFormButton && addressFormButton.classList.contains('disabled')) {
              addressFormButton.classList.remove('disabled');
            }

            if (organizationIdInput) {
              organizationIdInput.value = organizationIdFromApi;
            }
            formValues.deliveryOrganizationId = organizationIdFromApi;
            formValues.orderType = 'delivery';
            formValues.restaurantWorkingHoursStart = response.data.organizationDeliveryHoursStart;

            if (addressTitleInput) {
              addressTitleInput.value = title;
              formValues.title = title;
            }

            if (addressStreetId) {
              addressStreetId.value = streetId;
              formValues.streetId = streetId;
            }

            if (addressHouseInput) {
              addressHouseInput.value = house;
              formValues.house = house;
            }

            if (addressStreetInput) {
              addressStreetInput.value = street;
              formValues.street = street;
            }

            if (addressFlatInput && flat) {
              addressFlatInput.value = flat;
              formValues.flat = flat;
            }

            if (addressFloorInput && floor) {
              addressFloorInput.value = floor;
              formValues.floor = floor;
            }

            if (addressEntranceInput && entrance) {
              addressEntranceInput.value = entrance;
              formValues.entrance = entrance;
            }

            if (commentInput && comment) {
              commentInput.value = comment;
              formValues.comment = comment;
            }

            if (addressFormSubmitButton) {
              addressFormSubmitButton.classList.remove('disabled');
            }

            if (sessionStorage) {
              sessionStorage.setItem(
                'formValues',
                JSON.stringify(formValues),
              );
            }

            if (textInput) {
              [].forEach.call(textInput, (input) => {
                if (input.hasAttribute('required')) {
                  input.removeAttribute('required');
                }
              });
            }

            if (buildingInput && buildingInput.hasAttribute('required')) {
              buildingInput.removeAttribute('required');
            }
          }
        }
      });
    });
  }

  if (saveAddressCheckbox) {
    saveAddressCheckbox.addEventListener('click', () => {
      if (saveAddressInput) {
        if (saveAddressCheckbox.checked) {
          saveAddressInput.value = saveAddressCheckbox.checked;

          if (addressTitleWrapper) {
            addressTitleWrapper.classList.add('visible');
          }
        } else {
          saveAddressInput.value = '';

          if (addressTitleWrapper) {
            addressTitleWrapper.classList.remove('visible');
          }

          if (addressTitleError) {
            addressTitleError.classList.remove('visible');
          }
        }
      }
    });
  }

  if (newAddressCodeInput) {
    newAddressCodeInput.addEventListener('input', (e) => {
      const { value } = e.target;

      if (codeInput) {
        codeInput.value = value;
      }
    });
  }

  if (newAddressCommentInput) {
    newAddressCommentInput.addEventListener('input', (e) => {
      const { value } = e.target;

      if (commentInput) {
        commentInput.value = value;
        formValues.comment = value;
      }
    });
  }

  if (restaurantRadionInput) {
    [].forEach.call(restaurantRadionInput, (input) => {
      if (
        formValues.organizationId &&
        formValues.organizationId === input.dataset.organizationid
      ) {
        input.checked = true;
      }

      input.addEventListener('click', () => {
        const workTime = input.dataset.worktime;
        const organizationId = input.dataset.organizationid;
        const pickupStartHours = input.dataset.pickupstarthours;
        const { house } = input.dataset;

        formValues.restaurantAddress = input.value;
        formValues.pickupStartHours = pickupStartHours;

        if (restaurantWorkTimeInput) {
          restaurantWorkTimeInput.value = workTime;
          formValues.workTime = workTime;
        }

        if (restaurantId) {
          restaurantId.value = organizationId;
          formValues.organizationId = organizationId;
          formValues.pickupOrganizationId = organizationId;
        }

        if (restaurantHouseInput) {
          restaurantHouseInput.value = house;
          formValues.restaurantHouse = house;
        }

        if (sessionStorage) {
          sessionStorage.setItem('formValues', JSON.stringify(formValues));
        }

        if (restaurantFormSubmitButton) {
          restaurantFormSubmitButton.classList.remove('disabled');
        }
      });
    });
  }

  if (newAddressInput) {
    newAddressInput.addEventListener('click', () => {
      formValues.menuType = 'delivery';
      if (sessionStorage) {
        sessionStorage.setItem(
          'formValues',
          JSON.stringify(formValues),
        );
      }

      if (addressFormSubmitButton) {
        addressFormSubmitButton.classList.remove('disabled');
      }

      if (textInput) {
        [].forEach.call(textInput, (input) =>
          input.setAttribute('required', 'required'),
        );
      }

      if (buildingInput) {
        buildingInput.setAttribute('required', 'required');
      }

      if (addressTitleInput) {
        addressTitleInput.value = '';
      }

      if (addressHouseInput) {
        addressHouseInput.value = '';
      }

      if (addressStreetInput) {
        addressStreetInput.value = '';
      }

      if (addressFlatInput) {
        addressFlatInput.value = '';
      }

      if (addressFloorInput) {
        addressFloorInput.value = '';
      }

      if (addressEntranceInput) {
        addressEntranceInput.value = '';
      }
    });
  }

  if (backButton) {
    backButton.addEventListener('click', () => {

      if (addressFormSubmitButton) {
        addressFormSubmitButton.classList.add('disabled');
      }

      if (newAddressInput) {
        newAddressInput.checked = false;
      }
    });
  }

  if (floorInput) {
    floorInput.addEventListener('input', (e) => {
      floorInput.value = e.target.value.replace(/[^0-9-/]/g, '');

      if (addressFloorInput) {
        addressFloorInput.value = e.target.value;
      }
    });
  }

  if (addressTitle) {
    addressTitle.addEventListener('input', (e) => {
      const { value } = e.target;

      formValues.title = value;

      if (addressTitleInput) {
        addressTitleInput.value = value;
      }
    });
  }

  if (addressStreet) {
    addressStreet.addEventListener('input', (e) => {
      const { value } = e.target;

      formValues.street = value;

      if (addressStreetInput) {
        addressStreetInput.value = value;
      }
    });
  }

  let houseTimeout;

  if (buildingInput) {
    buildingInput.addEventListener('input', (e) => {
      clearTimeout(houseTimeout);
      const { value } = e.target;

      if (addressStreet && addressStreet.value) {
        const deliveryAddress = `${addressStreet.value}, ${value}`;
        const { id } = addressStreet.dataset;

        if (addressFormSubmitButton) {
          addressFormSubmitButton.classList.add('disabled');
          addressFormSubmitButton.textContent = 'Загрузка...';
        }

        houseTimeout = setTimeout(async () => {
          const response = await fetchData(`/order/delivery-availability?address=${deliveryAddress}&streetKladrId=${id}`);

          if (response) {
            if (addressFormSubmitButton) {
              addressFormSubmitButton.classList.remove('disabled');
              addressFormSubmitButton.textContent = 'Сохранить';
            }

            const organizationIdInput = document.querySelector('.order-address-form .delivery-organization-id');
            const addressFormButton = document.querySelector('.order-address-form .address-submit');

            if (!response.data.deliveryAvailable) {
              if (addressFormButton && !addressFormButton.classList.contains('disabled')) {
                addressFormButton.classList.add('disabled');
              }

              if (addressStreetError) {
                addressStreetError.classList.add('visible');
                addressStreetError.textContent =
                  'Мы не можем доставить заказ по текущему адресу';
              }

              buildingInput.value = '';

              if (formValues.street) {
                formValues.street = '';
              }

              if (formValues.house) {
                formValues.house = '';
              }

              if (formValues.deliveryOrganizationId) {
                formValues.deliveryOrganizationId = '';
              }

              if (organizationIdInput && organizationIdInput.value) {
                organizationIdInput.value = '';
              }
            } else {
              if (addressFormButton && addressFormButton.classList.contains('disabled')) {
                addressFormButton.classList.remove('disabled');
              }

              if (addressStreetError) {
                addressStreetError.classList.remove('visible');
                addressStreetError.textContent = 'Введите улицу';
              }

              formValues.house = value;

              if (addressStreetInput) {
                formValues.street = addressStreetInput.value;
              }

              if (addressHouseInput) {
                addressHouseInput.value = value;
              }

              const organizationIdFromApi = response.data.organizationId;

              if (organizationIdInput) {
                organizationIdInput.value = organizationIdFromApi;
              }

              formValues.deliveryOrganizationId = organizationIdFromApi;
              formValues.restaurantWorkingHoursStart = response.data.organizationDeliveryHoursStart;
            }
          }
        }, 300);
      } else {
        formValues.house = value;

        if (addressHouseInput) {
          addressHouseInput.value = value;
        }
      }

      if (!value && !addressStreet.value && addressStreetError) {
        addressStreetError.classList.remove('visible');
        addressStreetError.textContent = '';
      }
    });
  }

  if (addressFlat) {
    addressFlat.addEventListener('input', (e) => {
      const { value } = e.target;

      formValues.flat = value;

      if (addressFlatInput) {
        addressFlatInput.value = value;
      }
    });
  }

  if (addressEntrance) {
    addressEntrance.addEventListener('input', (e) => {
      const { value } = e.target;

      formValues.entrance = value;

      if (addressEntranceInput) {
        addressEntranceInput.value = value;
      }
    });
  }

  let streetTimeout;

  if (streetInput) {
    streetInput.addEventListener('input', (e) => {
      const { value } = e.target;

      clearTimeout(streetTimeout);

      if (value) {
        streetTimeout = setTimeout(async () => {
          const response = await fetchData(`/streets?name=${value}`);

          if (response) {
            if (streetsList) {
              streetsList.classList.add('visible');
              streetsList.innerHTML = '';

              if (response.data.length) {
                const streets = response.data.map(
                  (street) =>
                    `<li>
                    <button class="street-btn small-text" data-id="${street.streetKladr}">${street.address}</button>
                  </li>`,
                );

                streetsList.innerHTML = streets.join('');
              } else {
                const li = document.createElement('li');

                li.classList.add('small-text');
                li.classList.add('empty-street');
                li.textContent = 'Адрес не найден';

                streetsList.append(li);
              }
            }
          }
        }, 300);
      } else {
        streetsList.innerHTML = '';
        streetsList.classList.remove('visible');
        addressStreetError.classList.remove('visible');
        addressStreetError.textContent = '';
      }
    });
  }

  if (streetsList) {
    streetsList.addEventListener('click', async (e) => {
      e.preventDefault();

      if (e.target.classList.contains('street-btn')) {
        const { id } = e.target.dataset;
        const street = e.target.innerHTML;

        if (addressStreet) {
          addressStreet.value = street;
          addressStreet.dataset.id = id;
        }

        if (buildingInput && buildingInput.value) {
          const deliveryAddress = `${street}, ${buildingInput.value}`;

          if (addressFormSubmitButton) {
            addressFormSubmitButton.classList.add('disabled');
            addressFormSubmitButton.textContent = 'Загрузка...';
          }

          const response = await fetchData(`/order/delivery-availability?address=${deliveryAddress}&streetKladrId=${id}`);

          if (response) {
            if (addressFormSubmitButton) {
              addressFormSubmitButton.classList.remove('disabled');
              addressFormSubmitButton.textContent = 'Сохранить';
            }

            const organizationIdInput = document.querySelector('.order-address-form .delivery-organization-id');
            const addressFormButton = document.querySelector('.order-address-form .address-submit');

            if (!response.data.deliveryAvailable) {
              if (addressFormButton && !addressFormButton.classList.contains('disabled')) {
                addressFormButton.classList.add('disabled');
              }

              if (addressStreetError) {
                addressStreetError.classList.add('visible');
                addressStreetError.textContent =
                  'Мы не можем доставить заказ по текущему адресу';
              }

              if (addressStreetInput) {
                addressStreetInput.value = '';
              }

              if (formValues.street) {
                formValues.street = '';
              }

              if (formValues.house) {
                formValues.house = '';
              }

              if (formValues.deliveryOrganizationId) {
                formValues.deliveryOrganizationId = '';
              }

              if (organizationIdInput && organizationIdInput.value) {
                organizationIdInput.value = '';
              }
            } else {
              if (addressFormButton && addressFormButton.classList.contains('disabled')) {
                addressFormButton.classList.remove('disabled');
              }

              if (addressStreetError) {
                addressStreetError.classList.remove('visible');
                addressStreetError.textContent = 'Введите улицу';
              }

              if (streetIdInput) {
                streetIdInput.value = id;
                formValues.streetId = id;
              }

              if (addressStreetInput) {
                addressStreetInput.value = street;
                formValues.street = street;
              }

              if (streetInput) {
                streetInput.value = street;
              }

              const organizationIdFromApi = response.data.organizationId;

              if (organizationIdInput) {
                organizationIdInput.value = organizationIdFromApi;
              }

              formValues.deliveryOrganizationId = organizationIdFromApi;
              formValues.orderType = 'delivery';
              formValues.restaurantWorkingHoursStart = response.data.organizationDeliveryHoursStart;
            }
          }
        } else {
          if (streetIdInput) {
            streetIdInput.value = id;
            formValues.streetId = id;
          }

          if (addressStreetInput) {
            addressStreetInput.value = street;
            formValues.street = street;
          }

          if (streetInput) {
            streetInput.value = street;
          }
        }

        streetsList.classList.remove('visible');
      }
    });
  }

  if (orderAddressForm) {
    orderAddressForm.addEventListener('submit', (e) => {
      if (
        newAddressInput &&
        newAddressInput.checked &&
        ((saveAddressCheckbox &&
          saveAddressCheckbox.checked &&
          !addressTitleInput.value) ||
          !addressHouseInput.value ||
          !addressStreetInput.value)
      ) {
        e.preventDefault();

        if (
          saveAddressCheckbox &&
          saveAddressCheckbox.checked &&
          !addressTitleInput.value &&
          addressTitleWrapper
        ) {
          addressTitleWrapper.classList.add('error');

          if (addressTitleError) {
            addressTitleError.classList.add('visible');
          }
        } else {
          addressTitleWrapper.classList.remove('error');

          if (addressTitleError) {
            addressTitleError.classList.remove('visible');
          }
        }

        if (!addressHouseInput.value && addressHouseWrapper) {
          addressHouseWrapper.classList.add('error');

          if (addressHouseError) {
            addressHouseError.classList.add('visible');
          }
        } else {
          addressHouseWrapper.classList.remove('error');

          if (addressHouseError) {
            addressHouseError.classList.remove('visible');
          }
        }

        if (!addressStreetInput.value && addressStreetTitle) {
          addressStreetTitle.classList.add('error');

          if (addressStreetError) {
            addressStreetError.classList.add('visible');
          }
        } else {
          addressStreetTitle.classList.remove('error');

          if (addressStreetError) {
            addressStreetError.classList.remove('visible');
          }
        }
      } else {
        if (newAddressInput &&
          newAddressInput.checked) {
          formValues.title = "";
        }

        if (sessionStorage) {
          sessionStorage.setItem('formValues', JSON.stringify(formValues));
        }
      }
    });
  }
});
